import http from './request';

const getHospitalList = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/banyan/consultation/listHospital',
  data: params,
});
// http.post('/banyan/consultation/listHospital', { ...params, });

// 新医院列表接口（用于特定渠道）
const getNewHospitalList = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/consultation/listHospital',
  data: params,
});
// 根据订单号查询用户信息
const getUserInfoByOrderNumberApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/minos/mini/consult/order/getUserInfoByOrderNumber',
  data: params,
});

// 带患者信息直接发起专家问诊
const createDoctorConsultationApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/minos/mini/consult/order/createDoctorConsultation',
  data: params,
});

export { getHospitalList, getNewHospitalList, getUserInfoByOrderNumberApi, createDoctorConsultationApi } ;
